import { useEffect, useState } from "react";
import { mainlandAppStoreHref } from "./appStoreHref";

// 系统时区在这两个里就当作人在大陆网络：这是代理信号，不是精确判断，误判只影响商品页显示哪个区。
const MAINLAND_TIME_ZONES = ["Asia/Shanghai", "Asia/Urumqi"];

/**
 * 首屏与预渲染都用传入的链接；水合后若访客系统时区属于大陆，换成 mainlandAppStoreHref 的结果。
 * 判断必须放在 effect 里：预渲染在开发机上跑，时区同样可能是上海，放模块顶层会把 /cn/ 烤进静态 HTML。
 */
export function useAppStoreHref(href: string, locale: string): string {
  const [resolved, setResolved] = useState(href);
  useEffect(() => {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setResolved(MAINLAND_TIME_ZONES.includes(zone) ? mainlandAppStoreHref(href, locale) : href);
  }, [href, locale]);
  return resolved;
}
